import React from 'react'
import BigNumber from 'bignumber.js'
// import Slider from 'react-slick';
import styled from 'styled-components'
import { Flex } from 'penguinfinance-uikit2'
import { useWeb3React } from '@web3-react/core'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { usePools, useV2Pools } from 'state/hooks'
import Page from 'components/layout/Page'

import FarmStakingCard from './components/FarmStakingCard'
import TotalValueLockedCard from './components/TotalValueLockedCard'
// import FirstSliderImage from './components/SlideComponents/FirstSliderImage'
// import CryptoPuffiesBanner from './components/SlideComponents/CryptoPuffiesBanner'
// import EmperorBanner from './components/SlideComponents/EmperorBanner'
import CompletedIDOs from './components/CompletedIDOs/CompletedIDOs'
// import EmperorCard from './components/EmperorCard'
import GamesCard from './components/GamesCard';
import ArenaGameBanner from './components/SlideComponents/ArenaGameBanner';
// import PuffyMint from './components/SlideComponents/PuffyMint'
// import PuffyIgloo from './components/SlideComponents/PuffyIgloo'

// function SampleNextArrow(props) {
//   const { className, style, onClick } = props;
//   return (
//     <div
//       className={className}
//       // onClick={onClick}
//     >
//       <img src={`${process.env.PUBLIC_URL}/images/home-v2/slider-images/arrow_right.svg`} alt='next_arrow' />
//     </div>
//   );
// }

const Home: React.FC = () => {
  const { account } = useWeb3React()
  const v1Pools = usePools(account)
  const v2Pools = useV2Pools(account)
  // const { isXl } = useMatchBreakpoints()
  // const isMobile = !isXl

  const v1PoolsWithApy = v1Pools.map((pool) => {
    return {
      ...pool,
      apy: new BigNumber(0),
    }
  })

  const v2PoolsWithApy = v2Pools.map((pool) => {
    return {
      ...pool,
    }
  })
  const xPefiPool = v1PoolsWithApy.length > 0 ? v1PoolsWithApy[0] : null
  const iPefiPool = v2PoolsWithApy.length > 0 ? v2PoolsWithApy[0] : null

  // const settings = {
  //   dots: false,
  //   infinite: true,
  //   autoplaySpeed: 15000,
  //   autoplay: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   nextArrow: <div><ArrowImg src={`${process.env.PUBLIC_URL}/images/home-v2/slider-images/arrow_right.svg`} alt='next_arrow' /></div>,
  //   prevArrow: <div><ArrowImg src={`${process.env.PUBLIC_URL}/images/home-v2/slider-images/arrow_left.svg`} alt='prev_arrow' /></div>
  // }

  return (
    <>
      <StyledPage>
        <BgWrapper>
          <BgContainer />
        </BgWrapper>
        <ArenaGameBanner />
        {/* <PuffyMint /> */}
        {/* <SliderContainer>
          <Slider {...settings}>
            <ImageWrapper>
              <EmperorBanner />
            </ImageWrapper>
            <ImageWrapper>
              <FirstSliderImage />
            </ImageWrapper>
          </Slider>
        </SliderContainer> */}
        <StyledContainer>
          {/* <CardWrapper>
            <EmperorCard />
          </CardWrapper> */}
          <CardWrapper>
            <GamesCard />
          </CardWrapper>
          {/* <HarvestFarmCard /> */}
          <CardWrapper>
            <FarmStakingCard pool={iPefiPool} />
          </CardWrapper>
          <TotalValueLockedCard v1Pool={xPefiPool} v2Pool={iPefiPool} />
          <CompletedIDOs />
          <SpacingWrapper />
        </StyledContainer>
      </StyledPage>
    </>
  )
}

const StyledPage = styled(Page)`
  min-width: 100%;
  padding: 0;
`

const BgWrapper = styled.div`
  background: ${({ theme }) => (theme.isDark ? '#1A1028' : '#F0F0F0')};
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
  z-index: -1;
`

const BgContainer = styled.div`
  background-image: url('/images/home-v2/new_bg.png');
  background-repeat: repeat;
  background-size: contain;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0px;
  left: 0px;
  z-index: -1;
`

const StyledContainer = styled.div`
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding: 16px;
  overflow: hidden;
`

// const SliderContainer = styled.div`
//   width: 100%;

//   .slick-slide {
//     height: 256px;

//     @media (min-width: 640px) {
//       height: 320px;
//     }
//     @media (min-width: 768px) {
//       height: 400px;
//     }
//     @media (min-width: 968px) {
//       height: 500px;
//     }
//   }

//   .slick-arrow {
//     position: absolute;
//     z-index: 10;
//   }

//   .slick-arrow:before {
//     font-size: 50px;
//     display: none;
//   }

//   .slick-arrow.slick-next {
//     right: 5%;

//     @media (min-width: 640px) {
//       right: 7%;
//     }
//     @media (min-width: 968px) {
//       right: 10%;
//     }
//     @media (min-width: 1200px) {
//       right: 3%;
//     }
//     @media (min-width: 1400px) {
//       right: 3%;
//     }
//     @media (min-width: 1600px) {
//       right: 10%;
//     }
//   }

//   .slick-arrow.slick-prev {
//     left: 5%;
//     display: none;

//     @media (min-width: 640px) {
//       left: 7%;
//     }
//     @media (min-width: 968px) {
//       right: 10%;
//     }
//     @media (min-width: 1200px) {
//       left: 3%;
//     }
//     @media (min-width: 1400px) {
//       left: 3%;
//     }
//     @media (min-width: 1600px) {
//       left: 10%;
//     }
//   }
// `

// const ArrowImg = styled.img`
//   width: 10px;
//   margin-top: -24px;
//   @media (min-width: 768px) {
//     width: 12px;
//   }
//   @media (min-width: 968px) {
//     width: 14px;
//     margin-top: 0px;
//   }
//   @media (min-width: 1200px) {
//     width: 20px;
//   }
//   @media (min-width: 1400px) {
//     width: 20px;
//   }
// `;

const CardWrapper = styled(Flex)`
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

// const ImageWrapper = styled.div`
//   overflow: hidden;
// `;
// const PefiStatsCardWrapper = styled.div``

const SpacingWrapper = styled.div`
  height: 24px;

  @media (min-width: 1200px) {
    height: 30px;
  }
`


export default Home
